<template>
  <v-app>
    <v-app-bar v-if="organization" app height="128px" :color="headerColor" :src="headerImage">
      <v-container fill-height fluid>
        <v-row no-gutters dense align="center">
          <a :href="webLink" target="_blank" class="nav ml-1">
            <img v-if="logo && $vuetify.breakpoint.smAndUp" :src="logo" :alt="organizationName" :title="organizationName" :height="100"/>
          </a>
          <v-spacer></v-spacer>
          <span class="text-h4 mr-5">{{organizationName}}</span>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-alert v-if="error" type="error" prominent shaped class="ma-5">
      Företaget hittades inte, kontrollera länken!
    </v-alert>

    <v-main v-else>
      <router-view/>
      <Footer v-if="organization" :organization="organization"/>
    </v-main>

    <v-footer app>
      <img :src="require('@/assets/logo-sm.png')" alt="Logo" :height="24"/>
      <span class="pl-2 subtitle-1 text--disabled">Powered by  <a href="https://inspectech.se/" target="_blank" class="nav">InspecTech</a></span>
    </v-footer>

  </v-app>
</template>

<script>
/* eslint-disable no-console, no-unused-vars */
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: { Footer },
  data () {
    return {
      error: false
    }
  },
  computed: {
    organization () {
      return this.$store.getters.organization
    },
    organizationName () {
      return this.$store.getters.setting('order.header.title') || this.organization?.name
    },
    headerColor () {
      return this.$store.getters.setting('order.header.color') || null
    },
    headerImage () {
      return this.$store.getters.setting('order.header.image') || null
    },
    logo () {
      return this.$store.state.logo
    },
    webLink () {
      let url = this.organization && this.organization.website
      if(url) {
        if(url.includes(':')) {
          return url
        }
        return 'http://' + url
      }
      return null
    }
  },
  methods: {
    loadMetadata () {
      return Promise.all([
          this.$store.dispatch('fetchOrderMetadata'),
          this.$store.dispatch('getCalendarEvents'),
          this.$store.dispatch('getNextPossibleDate')
        ]
      )
    },
    setTypesFromQuery() {
      const availableTypes = (this.$store.state.inspectionTypes || []).map(t => (t.value))
      const selectedTypes = this.$route.query.type
      if(selectedTypes) {
        this.$store.state.form.types = selectedTypes.split(',')
            .map(s => s.trim())
            .filter(type => availableTypes.includes(type))
      }
    }
  },
  created () {
    this.loadMetadata()
      .then(this.setTypesFromQuery)
      .catch(err => {
        this.error = true
      })
  }
}
</script>

<style scoped>
  .nav {
    text-decoration: none;
    color: inherit;
  }
  .nav:visited {
    color: inherit;
  }
</style>
